module.exports =  () => {
    require('bootstrap/js/dist/alert');
    require('bootstrap/js/dist/collapse');
    // node_modules\bootstrap\dist\js\bootstrap.js

    // alert('tasd');
    $('.btn-burguer').on('click', function () {
        $('.sticks').toggleClass('open');
    });
};
